import React from 'react';
import Ship2Air from 'components/Air/Ship2Air';
import CustomerForm from 'components/CustomerForm';

const AirFlow = ({ step, initialValues }) => {

  return (
    <>
      <>{step == 1 && (<Ship2Air />)}</>
      <>{step == 2 && (<CustomerForm initialValues={initialValues} />)}</>
    </>
  );
};

export default AirFlow;